module.exports = __webpack_public_path__ + "img/logo.png.bdc0e8f0.webp";